<template>
  <div class="row" v-if="temperatureSensorDelay.length">
    <div class="col-12">
      <div
        style="display: flex; flex: 1; justify-content: space-between"
        class="mb-2"
      >
        <div class="form-inline">
          <input
            type="text"
            v-model="search"
            class="form-control"
            placeholder="Pesquisar..."
          />
        </div>
      </div>

      <b-table
        id="temperature_sensor_delay_data"
        responsive="xl"
        bordered
        hover
        class="bg-white"
        :items="filteredTemperatureSensorDelay"
        :fields="fields"
      >
        <template #cell(vehicleId)="{ item }">
          <div class="text-center">
            <button
              class="edit btn btn-action btn-primary btn-circle light-bottom-shadow text-white"
              @click="() => loadLastPositions(item.vehicleId, item.vehicle)"
            >
              <i class="fas fa-eye fa-lg" style="color: black" />
            </button>
          </div>
        </template>

        <template #cell(datetime)="{ item }">
          <div>
            {{ toBRDatetime(item.datetime) }}
          </div>
        </template>

        <template #cell(temperatureSensorDatetime)="{ item }">
          <div>
            {{ toBRDatetime(item.temperatureSensorDatetime) }}
          </div>
        </template>

        <template #cell(HORAS_ATRASO)="{ item }">
          <div :class="{ 'text-danger': item.toAlertHourDelay }">
            <i
              v-show="item.toAlertHourDelay"
              class="fas fa-exclamation-triangle mr-1"
            />

            {{ item.HORAS_ATRASO }}
          </div>
        </template>

        <template #cell(distinctS1)="{ item }">
          <div :class="{ 'text-danger': item.toAlertDistinctS1 }">
            <i
              v-show="item.toAlertDistinctS1"
              class="fas fa-exclamation-triangle mr-1"
            />

            {{ item.distinctS1 }}
          </div>
        </template>
      </b-table>
    </div>

    <b-modal
      v-model="showLastPositionsModal"
      :title="last30PositionsTitleModal"
      size="xl"
      ok-only
      ok-title="Fechar"
    >
      <Positions :vehicleId="vehicleIdSelected" />
    </b-modal>
  </div>
</template>

<script>
import LoaderButton from "@/components/button/LoaderButton";
import Combobox from "@/components/shared/ComboBox";
import Positions from "@/components/shared/Positions.vue";
import { formatBoolean, formatDatetime } from "@/lib/util";
import { mapState } from "vuex";

export default {
  name: "TemperatureSensorDelayList",

  components: {
    LoaderButton,
    Combobox,
    Positions,
  },

  data() {
    return {
      fields: [
        {
          key: "vehicleId",
          label: "Últ. Posi.",
        },
        {
          key: "vehicle",
          label: this.$t("vehicle"),
        },
        {
          key: "client",
          label: this.$t("client"),
        },
        {
          key: "datetime",
          label: this.$t("datetime"),
        },
        {
          key: "temperatureSensorDatetime",
          label: "Data/Hora Sensor Temperatura",
        },
        {
          key: "HORAS_ATRASO",
          label: "Horas Atraso",
        },
        {
          key: "distinctS1",
          label: "Temp 1",
        },
      ],
      search: "",
      showLastPositionsModal: false,
      last30PositionsTitleModal: "",
      vehicleIdSelected: null,
    };
  },

  computed: {
    ...mapState({
      temperatureSensorDelay: (state) => state.temperaturesensordelay.all,
    }),

    rows() {
      return this.temperatureSensorDelay.length;
    },

    filteredTemperatureSensorDelay() {
      if (!this.search) {
        return this.temperatureSensorDelay;
      }

      const search = this.search.toLowerCase();

      return this.temperatureSensorDelay.filter((item) => {
        return (
          String(item.vehicle).toLowerCase().includes(search) ||
          String(item.client).toLowerCase().includes(search) ||
          String(item.vehiclePlate).toLowerCase().includes(search)
        );
      });
    },
  },

  methods: {
    toBRDatetime(date) {
      return formatDatetime(date);
    },

    loadLastPositions(vehicleId, title) {
      this.vehicleIdSelected = vehicleId;

      this.last30PositionsTitleModal = `Últimas 30 posições [${title}]`;

      this.showLastPositionsModal = true;
    },

    toBooleanString(value) {
      return formatBoolean(value);
    },
  },
};
</script>
